<i18n src="../../../locales/lang.json"></i18n>
<template>

  <table style="width:100%;">
    <tr>
      <td style="position: relative; display: table; overflow-x: hidden; overflow-y:auto; width:100%" v-bind:style="getHeight" v-bind:class="getBottomPaddingClass">
        <element-view-page class="animated" v-bind:class="animationclass" v-show="element.Visible == true" v-for="(element, index) in el.Elements" v-bind:el="element" v-bind:assigned="assigned" v-bind:date="date" v-bind:scheduleid="scheduleid" @deleteItem="deleteItem" @clickItem="clickItem" @openUrl="openUrl" />
      </td>
    </tr>
    <tr>
      <td>
        <procedure-pager @changed="changedPage" @done="doSave" v-bind:pages="el.Elements" />
      </td>
    </tr>
  </table>
</template>

<script>

  export default {
    name: "element-view-slideshow",
    components: {
      
    },
    props: {
      el: {
        type: Object,
        default: { Elements: []}
      },
      date: {
        required: false,
        tyrrpe: String,
        default: null
      },
      scheduleid: {
        required: false,
        type: String,
        default: null
      },
      assigned: {
        required: false,
        type: String,
        default: null
      },
      isshifttask: {
        required: false,
        type: Boolean,
        default: false
      },
      visible: {
        required: false,
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        animationclass: 'fadeIn',
        currentPage: 0,
      };
    },
    methods: {
      changedPage(elements, index) {

        if (index < this.currentPage)
          this.animationclass = "slideInLeft";
        else if (index > this.currentPage)
          this.animationclass = "slideInRight";
        else
          this.animationclass = "fadeIn";

        this.currentPage = index;
        this.el.Elements = elements;
        Vue.set(this.el, "Elements", elements)

        this.$emit("changed")
      },
      openUrl(el,val) {
        this.$emit('openUrl', el, val);
      },
      clickSettings(el) {
        this.$emit('clickSettings', el);
      },
      clickItem(el) {
        this.$emit('clickItem', el);
      },
      deleteItem(id) {
        if (id == null || typeof id == "undefined")
          id = this.value.Id;
        this.$emit('deleteItem', id);
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
  
        Vue.set(this.el, "Elements", this.el.Elements)
        this.$forceUpdate();
      },
      init() {
        // Set the first page as visible from the beginning
        if (this.el.Elements.length > 0) {
          this.el.Elements[0].Visible = true;
        }
        Vue.set(this.el, "Elements", this.el.Elements)
        this.$forceUpdate();
      },
      async doSave(closerightside) {
        if (this.procedure.ProcedureId != 0) {
          await this.saveExistingProcedure(closerightside);
        }
        else {
          await this.saveNewProcedure(closerightside);
        }
      },
      async saveNewProcedure(closerightside) {

        var tmpProcedure = { name: this.procedure.ProcedureName, istask: this.procedure.IsTask };
        tmpProcedure.Settings = { Property: [] };
        tmpProcedure.Settings.Property["EnablePrivateChat"] = "True";
        var createProcedureData = JSON.stringify(tmpProcedure);
        var thisContext = this;
        var response = await this.$http.post(
          '/api/Procedure/AddProcedure',
          createProcedureData,
          {
            headers: {
              'Content-Type': 'application/json',
              "Accept": "application/json"
            }
          }
        )
          .then(response => {
            thisContext.$root.$emit('doSearch');
            var proc = thisContext.procedure;
            proc.ProcedureId = response.data.Id;
            proc.CategoryId = 1;
            this.scheduleid = response.data.ProcedureScheduleId;
            thisContext.procedure = proc;
            thisContext.saveExistingProcedure(closerightside);
          });
      },

      async saveExistingProcedure(closerightside) {
        //var request = this.procedure;      
        var request = {
          procedureViewModel: this.procedure,
        };
        try {
          var response = await this.$http.put(
            '/api/Procedures/v1/UpdateProcedure',
            request,
            {
              headers: {
                'Content-Type': 'application/json',
                "Accept": "application/json"
              }
            }
          )
            .then(async response => {


              var isValid = this.validateProcedure(this.procedure);
              if (isValid == true) {
                vm.$root.$emit('doSearch');
                var proc = JSON.parse(JSON.stringify(this.procedure));
                proc.ProcedureId = response.data.ProcedureId;
                proc.CategoryId = response.data.CategoryId
                proc.Description = response.data.Description;
                proc.ProcedureName = response.data.ProcedureName;
                proc.Elements = response.data.Elements;

                this.$emit('procedure_saved');
                this.$store.commit('loadnewProcedure', proc);

                if (closerightside == true) {
                  //saved, and closing window
                  this.$root.$emit('procedure_editor_can_close');
                }
                else {
                  // saved, but staying"
                }

              }
              else {
                //alert("something needs fixing")
              }

            });

        } catch (err) {
        }
      },
      validateProcedure(procedure) {
        var result = [];
        for (var i = 0; i < procedure.Elements.length; i++) {
          var childRes = this.validateProcedureElements(procedure.Elements[i], result)
          if (childRes.length > 0)
            result.push(childRes)
        }
        this.procedure = procedure;
        this.$store.commit('updateprocedure', procedure);
        if (result.length > 0) {
          this.hasErrors = true;
          return false;
        }
        this.hasErrors = false;
        return true;
      },
      validateProcedureElements(element) {
        var result = []
        for (var i = 0; i < element.Elements.length; i++) {
          var childRes = this.validateProcedureElements(element.Elements[i], result);
          if (childRes.length > 0)
            result.push(childRes)
        }
        if (element.Required == true) {
          if (!element.UserInputs || element.UserInputs == null || element.UserInputs == 0) {
            result.push("error");
            element.hasErrors = true;
          }
          else
            element.hasErrors = false;
        }
        return result;
      },
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 9");
          this.$store.commit('saveprocedure', value)
        }
      },
      getHeight: {
        get() {
          var height = window.innerHeight;
          var margin = 115;
          if (this.$store.isMobile())
            margin = 85;
          if (this.$store.getHelptextVisible())
            margin += 80;
          if (this.$store.getMenuVisible())
            margin += 65;
          height = height - margin;
          return "height: " + height + "px;"
        },
      },
    },
    watch: {
    },
    mounted() {
      this.init();
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
    created() {

    },
  };

</script>

<style scoped>
  

</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-viewing-elements/element-view-slideshow.vue